<template>
  <div>
    <div
      class="flex flex-wrap gap-2 mt-5"
      role="group"
      :aria-label="`${noun} status`"
    >
      <button
        v-for="tab in statusOrder"
        :key="tab"
        type="button"
        class="btn capitalize"
        :class="status === tab ? 'btn-primary' : 'btn-outline-secondary'"
        :aria-pressed="status === tab"
        :disabled="tab === 'stale' && !reviewWindow"
        @click="$emit('update:status', tab)"
      >
        {{ tab }} {{ noun }}
        <span v-if="counts[tab] !== null" class="ml-2"
          >({{ counts[tab] }})</span
        >
      </button>
    </div>
    <p v-if="reviewWindow" class="mt-3 text-gray-600">
      Preparing for {{ reviewWindow.eventYear }} · History checked:
      {{ reviewWindow.years.join(" and ") }}.
    </p>
    <p v-else-if="loaded" class="mt-3 text-red">
      Stale review is unavailable until a valid event year is saved.
    </p>
    <div class="flex flex-wrap items-center justify-between gap-3 mt-5">
      <label class="block">
        <span class="sr-only"
          >Search {{ noun }} across all pages in this tab</span
        >
        <input
          :value="search"
          type="search"
          class="form-control w-80"
          maxlength="200"
          :placeholder="`Search all ${status} ${noun.toLowerCase()}…`"
          @input="$emit('update:search', $event.target.value)"
        />
      </label>
      <span>{{ total }} matching {{ noun.toLowerCase() }}</span>
      <slot />
    </div>
    <div v-if="error" class="mt-4 text-red" role="alert">
      {{ error }}
      <button
        type="button"
        class="btn btn-outline-secondary ml-3"
        :disabled="loading"
        @click="$emit('retry')"
      >
        Try again
      </button>
    </div>
    <p v-if="loading" class="mt-4" role="status">
      Loading {{ noun.toLowerCase() }}…
    </p>
    <p v-else-if="!error && !total" class="mt-4" role="status">
      No matching {{ noun.toLowerCase() }}.
    </p>
  </div>
</template>
<script>
export default {
  props: {
    noun: { type: String, required: true },
    status: { type: String, required: true },
    statusOrder: {
      type: Array,
      default: () => ["active", "inactive", "stale"]
    },
    search: { type: String, required: true },
    counts: { type: Object, required: true },
    total: { type: Number, required: true },
    reviewWindow: { type: Object, default: null },
    loaded: Boolean,
    loading: Boolean,
    error: { type: String, default: "" }
  },
  emits: ["update:status", "update:search", "retry"]
};
</script>
<style scoped>
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
